export const AVATAR_SIZES = {
  xs: 20,
  sm: 24,
  md: 32,
  header: 40,
  lg: 48,
  xl: 80,
  '2xl': 96,
  '3xl': 120,
} as const;

export type AvatarSize = keyof typeof AVATAR_SIZES;

export const FONT_SIZES: Record<AvatarSize, number> = {
  xs: 12,
  sm: 12,
  md: 14,
  header: 12,
  lg: 24,
  xl: 32,
  '2xl': 32,
  '3xl': 32,
};
